import { useService } from 'react-reservice';

import maintenanceService from './service';

export const useMaintenance = () => {
  return useService(maintenanceService, (state) => state);
};

export { maintenanceService };
